import React, { useContext, useEffect, useRef } from "react";
import styles from "./Footer.module.scss";
import PathContext from "../../context/path";
import StateContext from "../../context/states";
const Footer = () => {
  const path = useContext(PathContext);
  const state = useContext(StateContext);
  const { isMobile, page } = state;
  const refWrap = useRef(null);
  useEffect(() => {
    const wrap = refWrap.current;
    if (isMobile && styles[`wrap_${page}`] !== undefined) {
      wrap.classList = `${styles.wrap} ${styles[`wrap_${page}`]}`;
    }
    return () => {
      wrap.classList = `${styles.wrap}`;
    }
  }, [isMobile, page])
  return (
    <>
      <div className={styles.wrap} ref={refWrap}>
        <div className={styles.col}>
          <div className={styles.copy}>© 2025</div>
        </div>
        <div className={styles.col}>

        </div>
        <div className={styles.col}>
          <div className={styles.links}>
            <a href="https://t.me/pravo_team" target="_blank" rel="noopener noreferrer" className={styles.link}>
              <img src={`${path}/img/icon-tg.svg`} alt="" />
            </a>
            {/* <a href="http://" target="_blank" rel="noopener noreferrer" className={styles.link}>
              <img src={`${path}/img/icon-vk.svg`} alt="" />
            </a>
            <a href="http://" target="_blank" rel="noopener noreferrer" className={styles.link}>
              <img src={`${path}/img/icon-yt.svg`} alt="" />
            </a> */}
          </div>
        </div>

      </div>
    </>
  );

}

export default Footer;
